/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Tue Dec 03 2024
 **/

import { Configure } from "@/frameworks/libraries";

export default function orderCallUser(userList: string[], callerID: string, requestedUsers?: string[]) {
	return userList.sort((a, b) => {
		// 내 ID가 가장 앞에 오도록
		if (a === Configure.userID) return -1;
		if (b === Configure.userID) return 1;

		// 다음 caller
		if (a === callerID) return -1;
		if (b === callerID) return 1;

		// 통화 대기중인 유저는 마지막
		const isRequestedA = requestedUsers?.includes(a);
		const isRequestedB = requestedUsers?.includes(b);

		if (isRequestedA && !isRequestedB) return 1;
		if (!isRequestedA && isRequestedB) return -1;

		return 0;
	});
}
